import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { LEFTRIGHT_PADDING } from '../config/style.config';
import TitleLeftSvg from '../svgs/TitleLeftSvg'
import PhotoManagementPanel from '../components/PhotoManagementPanel'

function Screen(props) {
    const hasPerms = props.control.permissions
    // console.log(hasPerms)
   
    return(
         <div className='w-full h-full bg-[#0C0D14]' style={{overflowY:'auto'}}>
            <div style={{...LEFTRIGHT_PADDING}} className='w-full h-full flex flex-col'>
                <div className="flex flex-row mt-[40px] justify-between">
                    <div className='flex flex-row items-center'>
                        <TitleLeftSvg className='mr-[9px]'/>
                        <div className="text-[24px] text-white font-bold ">Photo Management</div>
                    </div>
                    {/* <div className="flex flex-row items-center  gap-[8px]">
                        <div className="button_white" onClick={()=>{navigate('/permit/template')}}>Cancel</div>
                        <div className="button_blue" style={{}} onClick={save()}>Save</div>
                    </div> */}
                </div>
                <div className='w-full flex-1'>
                    <PhotoManagementPanel />
                </div>
            </div>
        </div>
    )
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
  })(Screen)